import { html, ref, repeat, when } from '@microsoft/fast-element';
import type { IndividualProjectsDrilldown } from './individual-projects-drilldown';
import { starUnHighlightedIcon, greenCheckIcon, circledError } from '../../../../styles';
import { eventDetail } from '../../../../utils/formatting';
import {
  TECHNOLOGY,
  PROJECT_OPERATIONAL_STATUS,
  VPPA_RFQ_STATUS,
  generateProjectDescription,
} from '../../../../utils';
import SolarImg from '../../../../assets/solar-drilldown.jpg';
import WindImg from '../../../../assets/wind-drilldown.svg';

export const IndividualProjectsDrilldownTemplate = html<IndividualProjectsDrilldown>`
  <div class="individual-projects-drilldown">
    <zero-card class="project-drilldown-card no-padding-card" style="padding: 10px;">
      <div class="project-header-card">
        <div class="details-wrapper">
          <div class="project-name">${(x) => x.project?.NAME}</div>
          ${when(
            (x) => x.project?.PROJECT_OPERATIONAL_STATUS === PROJECT_OPERATIONAL_STATUS.OPERATIONAL,
            html`
              <div class="operational-status">
                <span>${(x) => x.getTechnologyIcon()}</span>
                <span>Operational</span>
              </div>
            `,
          )}
          ${when(
            (x) => x.project?.PROJECT_OPERATIONAL_STATUS === PROJECT_OPERATIONAL_STATUS.NEW_BUILD,
            html`
              <div class="operational-status">
                <span>${(x) => x.getTechnologyIcon()}</span>
                <span>New Build</span>
              </div>
            `,
          )}
        </div>
        <div
          class="image-container"
          style="background-image: url(${(x) =>
            x.project?.TECHNOLOGY === TECHNOLOGY.WIND ? WindImg : SolarImg})"
        ></div>
        <div class="details-wrapper">
          <div class="company-name">${(x) => x.project?.CASCADE_COMPANY_NAME}</div>
          <zero-button
            ${ref('favProjectWatchlist')}
            type="button"
            @click=${(x) => x.favoriteWatchlistProject()}
            class="favorite-icon"
            style="display: ${(x) => (x.showWatchlist ? '' : 'none')}"
          >
            ${starUnHighlightedIcon()}
          </zero-button>
        </div>
        <div class="project-description">${(x) => generateProjectDescription(x.project)}</div>
      </div>
      <div class="project-details-card">
        ${repeat(
          (x) => x.generalInformation,
          html`
            <div class="details-box">
              <span class="info-title">${(x) => x.title}</span>
              <span class="info-value">${(x) => x.value}</span>
            </div>
          `,
        )}
      </div>
      <div class="product-types-card">
        <h3 class="product-types-title">Product Types</h3>
        <div class="product-details">
          ${repeat(
            (x) => x.productType,
            html`
              <div>
                ${when(
                  (x) => x.type === true,
                  html`
                    <span>${greenCheckIcon()}</span>
                    <span>${(x) => x.name}</span>
                  `,
                )}
                ${when(
                  (x) => x.type === false,
                  html`
                    <span>${circledError()}</span>
                    <span>${(x) => x.name}</span>
                  `,
                )}
              </div>
            `,
          )}
        </div>
      </div>
    </zero-card>
    <zero-card class="project-vppas-card">
      <individual-projects-vppas
        class="auto-height"
        @favoriteWatchlistVppa="${(x, c) => x.favoriteWatchlistVppa(eventDetail(c))}"
        @selectVppa="${(x, c) => x.selectVppa(eventDetail(c))}"
        @productType="${(x, c) => (x.selectedProductType = eventDetail(c))}"
      ></individual-projects-vppas>
      ${when(
        (x) =>
          x.selectedVppa !== null &&
          x.selectedVppa?.VPPA_STATUS !== VPPA_RFQ_STATUS.AWAITING_KEY_METRICS,
        html`
          <individual-projects-graphs
            class="graph-container"
            :selectedVppa=${(x) => x.selectedVppa}
            :megawattAC=${(x) => x.project?.MEGAWATT_AC}
            :selectedProductType="${(x) => x.selectedProductType}"
          ></individual-projects-graphs>
        `,
      )}
      ${when(
        (x) =>
          x.selectedVppa === null ||
          x.selectedVppa?.VPPA_STATUS === VPPA_RFQ_STATUS.AWAITING_KEY_METRICS,
        html`
          <div class="no-graph-container">
            ${(x) =>
              x.selectedVppa?.VPPA_STATUS !== VPPA_RFQ_STATUS.AWAITING_KEY_METRICS
                ? 'Select Contract To View Graphs'
                : 'This Contract is Awaiting Key Metrics'}
          </div>
        `,
      )}
    </zero-card>
    <zero-card class="project-ranking-card">
      ${when(
        (x) => x.selectedVppa !== null,
        html`
          <project-metrics
            :projectId="${(x) => x.project?.PROJECT_ID}"
            :vppa="${(x) => x.selectedVppa}"
            :selectedProductType="${(x) => x.selectedProductType}"
          ></project-metrics>
        `,
      )}
    </zero-card>
  </div>
`;
